import { render, staticRenderFns } from "./MenuLeftWedding.vue?vue&type=template&id=95efa092&scoped=true"
import script from "./MenuLeftWedding.vue?vue&type=script&lang=js"
export * from "./MenuLeftWedding.vue?vue&type=script&lang=js"
import style0 from "./MenuLeftWedding.vue?vue&type=style&index=0&id=95efa092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95efa092",
  null
  
)

export default component.exports